import { type FC, useRef } from 'react';
import { ClickableIcon, type ClickableIconProps, IconHide, IconShow } from '@direct-frontend/components';
import { useToggle } from '@direct-frontend/stdlib';
import { type OpenApiSchemaProductCharacteristicWithAllSettings } from '#shared/api/schema';
import { Tooltip } from '#shared/ui/Tooltip';

type VisibilityCharacteristicProps = {
    characteristic: Pick<OpenApiSchemaProductCharacteristicWithAllSettings, 'is_hidden'>;
} & Omit<ClickableIconProps, 'children'>;

export const VisibilityCharacteristic: FC<VisibilityCharacteristicProps> = ({
    characteristic: { is_hidden },
    ...clickableIconProps
}) => {
    const { value: isTooltipOpen, toggleOff: closeTooltip, toggleOn: openTooltip } = useToggle(false);
    const refToggleVisible = useRef<HTMLButtonElement>(null);

    const IconToggleVisible = is_hidden ? IconHide : IconShow;

    return (
        <>
            <ClickableIcon
                onHoverStart={openTooltip}
                onHoverEnd={closeTooltip}
                ref={refToggleVisible}
                {...clickableIconProps}
            >
                <IconToggleVisible size="24" />
            </ClickableIcon>
            <Tooltip
                isOpen={isTooltipOpen}
                onClose={closeTooltip}
                title={is_hidden ? 'Не отображается на сайте' : 'Отображается на сайте'}
                triggerRef={refToggleVisible}
            />
        </>
    );
};
